import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DasUBoot} from "../DasUBoot";
import {SymbolUtils} from "../utils/SymbolUtils";
import {DasUBootSymbol, DasUBootSymbolStates} from "../reels/DasUBootSymbol";
import {gsap} from "gsap";
import {BetWayWinData} from "../server/DasUBootData";
import {BitmapText} from "pixi.js";
import {DasUBootGameAssets} from "../DasUBootGameAssets";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {DasUBootStatics} from "../utils/DasUBootStatics";
import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WinWayDisplay} from "../components/WinWayDisplay";

/**
 * Created by jonas on 2021-03-29.
 */

export class IndiSymWinPresentation implements SimplePresentation {
    private _mainTl: gsap.core.Timeline | undefined;

    start(controller: SimplePresentationRunnerController): void {
        if (this._mainTl) {
            this._mainTl.progress(1);
            this._mainTl = undefined;
        }
        this._mainTl = gsap.timeline();

        if (this._mainTl) {
            const betWayWinData: BetWayWinData[] = DasUBoot.model.gameData.betWayWins;
            betWayWinData.forEach((betWayWinData) => {
                let winWaysCont = this.getWinWaysCont(betWayWinData),
                    lastWinningCol: number = 0;
                const durr = this._mainTl?.duration();

                for (let col = 0; col < betWayWinData.reelWinPositions.length; col++) {
                    for (let row = 0; row < betWayWinData.reelWinPositions[col].length; row++) {
                        if (betWayWinData.reelWinPositions[col][row]) {
                            const sym = DasUBoot.reelView.getVisibleSymbolAt(col, row);
                            this._mainTl?.add(SymbolUtils.getSymbolStateAnimations([sym], DasUBootSymbolStates.WIN), durr);
                            lastWinningCol = col;
                        }
                    }
                }

                const winAmtWaysContSym = (<DasUBootSymbol>DasUBoot.reelView.getVisibleSymbolAt(lastWinningCol, betWayWinData.reelWinPositions[lastWinningCol].indexOf(true)).positionable)

                this._mainTl?.add(() => {
                    winAmtWaysContSym.addAmtWaysCont(winWaysCont);
                }, durr);
                this._mainTl?.add(() => {
                    winAmtWaysContSym.removeAmtWaysCont(winWaysCont);
                })

            });


            this._mainTl.add(() => {
                controller.finish();
            })
        }


    }

    shouldRun(): boolean {
        return DasUBoot.apiPlugin.gameClientConfiguration.displayIndividualWinsInGame && DasUBoot.model.winRatio > 0;
    }

    private getWinWaysCont(data: BetWayWinData): PIXI.Container {
        const cont: PIXI.Container = new PIXI.Container();
        const winNumber:BitmapText = new PIXI.BitmapText(SlotGame.apiPlugin.currency.formatValue(data.multipliedAmount), {
            fontName: DasUBootGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 60,
        });
        winNumber.pivot.set(winNumber.width/2,winNumber.height/2);

        const winWays:WinWayDisplay= new WinWayDisplay(true,20);
        winWays.setWays(data.numberOfCombinations);
        winWays.position.y=50;

        cont.addChild(winNumber, winWays);
        return cont;
    }
}